import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

export const Title = styled.h2`
  font-size: ${themeGet('fontSizes.h2')};
  line-height: 1.42;
  font-weight: normal;
  margin: 0;
  ${space}
`;
